import { useCallback, useEffect, useState } from 'react'

interface ResendHeaderProps {
  maxCooldown?: number
  onResend: () => void
}

export default function ResendHeader({
  maxCooldown = 30,
  onResend,
}: ResendHeaderProps) {
  const [resendCooldown, setResendCooldown] = useState(0)

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (resendCooldown > 0) {
      timer = setInterval(() => {
        setResendCooldown((prev) => {
          if (prev <= 1) clearInterval(timer)
          return prev - 1
        })
      }, 1000)
    }
    return () => clearInterval(timer)
  }, [resendCooldown])

  const handleResend = useCallback(() => {
    if (resendCooldown <= 0) {
      onResend()
      setResendCooldown(maxCooldown)
    }
  }, [resendCooldown, onResend, maxCooldown])

  return (
    <div className="w-full flex justify-between items-center">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Verification code
      </label>
      <button
        type="button"
        className="text-blue-600 text-sm hover:underline disabled:opacity-50"
        onClick={handleResend}
        disabled={resendCooldown > 0}
      >
        {resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend code'}
      </button>
    </div>
  )
}
